import { configureStore, combineReducers } from "@reduxjs/toolkit";
import changeLang from "../slices/changeLang";
import settings from "../slices/settings";
import qrTemplates from "../slices/qrTemplates";
import qrFrames from "../slices/qrFrames";
import qrText from "../slices/qrTextSettings";
import qrSettings from "../slices/qrSettings";
import getQrLinkSlice from "../slices/getQrLinkSlice";
import qrOptions from "../slices/qrOptions";

const rootReducer = combineReducers({
  getQrLinkSlice,
  changeLang,
  settings,
  qrTemplates,
  qrFrames,
  qrText,
  qrSettings,
  qrOptions,
});

export const adminStore = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
